export const LOGIN_ROUTE = '/entrar';
export const API_LOGIN_PATH = '/api/login';
export const API_LOGOUT_PATH = '/api/logout';
export const HOME_ROUTE = '/';
export const PASSWORD_RESET_ROUTE = '/recuperar-senha';
export const ADMIN_DASHBOARD_ROUTE = '/admin';
export const PRIVACY_POLICY_ROUTE = '/privacidade';
export const TERMS_OF_USE_ROUTE = '/termos';
